function validatePassword(value) {
    if (!value) return true;

    const errors = [];

    if (value.length < 12) {
        errors.push("Password must be at least 12 characters");
    }
    if (!/[A-Z]/.test(value)) {
        errors.push("Password must contain at least one uppercase letter");
    }
    if (!/[a-z]/.test(value)) {
        errors.push("Password must contain at least one lowercase letter");
    }
    if (!/\d/.test(value)) {
        errors.push("Password must contain at least one number");
    }
    if (!/[!@#$%^&*()\-_=+]/.test(value)) {
        errors.push("Password must contain at least one special character");
    }

    return errors.length ? errors.join(", ") : true;
}

module.exports = { validatePassword };
